import { Avatar, Box, Chip, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import salesRepresentativeRoutes from "../../../constants/salesRepresentativeRoutes";

type Props = {
  nameClient: string;
  code: string;
  tel: string;
  status: string;
  bg: string;
  onClickNum: () => void; 
};

const CustomClient = ({ nameClient, code, tel, status, bg , onClickNum}: Props) => {
  const navigate = useNavigate();  

  const handleClick = () => {
    onClickNum(); 
    navigate(`/${salesRepresentativeRoutes.INFOS_CLIENTS_REPRESENTANT}`);  
  };

  function stringAvatar(nameClient: string) {
    const nameParts = nameClient.split(" ");
    if (nameParts.length >= 2) {
      return {
        children: `${nameParts[0][0]}${nameParts[1][0]}`,
      };
    } else {
      return {
        children: nameClient[0],
      };
    }
  }

  return (
    <Grid
      container
      mb={2}
      p={3}
      sx={{
        border: "1px solid #F2F2F2",
        borderRadius: "8px",
        boxShadow: "0 1px 0px rgba(0, 0, 0, 0.1)",
        cursor: "pointer",
      }}
      onClick={handleClick} 
    >
      <Grid item xs>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar
            sx={{
              backgroundColor: "#E73939",
              width: 56,
              height: 56,
            }}
            {...stringAvatar(nameClient)}
          />
          <Box>
            <Typography
              variant="body1"
              sx={{ color: "#464E5F", fontSize: "16px", fontWeight: "bold" }}
            >
              {nameClient}
            </Typography>
            <Typography sx={{ color: "#464E5F" }}>{code}</Typography>
          </Box>
        </Stack>
      </Grid>
      <Grid item xs>
        <Stack direction="column">
          <Typography sx={{ color: "#464E5F", fontSize: "16px" }}>
            Numéro de téléphone
          </Typography>
          <Typography sx={{ color: "#464E5F", fontWeight: "bold" }}>
            {tel}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Chip
            label={"STATUT : " + status}
            sx={{
              color: "#fff",
              background: bg,
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default CustomClient;
